import React, {useState, useEffect, useRef} from 'react'
import EditNewCard from '../UpdateCard/EditBoardCard'
import 'react-loading-skeleton/dist/skeleton.css'

import {useEditModal} from '../../context/ShowEditModalQuill'
import EditPageModal from '../Modals/EditPageModal'
import { useTheme } from '../../context/ThemeContext'
import { useSelector } from 'react-redux'

const LinkCardUpdate: React.FC = () => {
  const {card, showEditModalQuill, setShowEditModalQuill, cardHistory, goBackInHistory, clearHistory, setCard} = useEditModal()
  const {theme} =useTheme()
  const { pagesByBoardId:pages } = useSelector((state: any) => state.pageReducer)

  const [modalStates, setModalStates] = useState<{[key: string]: boolean}>({})
  const [currentCard, setCurrentCard] = useState<any>(null)
  const [localCanGoBack, setLocalCanGoBack] = useState(false)
  const isNavigatingRef = useRef(false)

  // Sync local canGoBack with context cardHistory
  useEffect(() => {
    setLocalCanGoBack(cardHistory.length > 0)
  }, [cardHistory.length])

  useEffect(() => {
    if (showEditModalQuill === true && card && card.id) {
      isNavigatingRef.current = true
      setCurrentCard(card)
      setModalStates((prev) => ({...prev, [card.id]: true}))
      setShowEditModalQuill(false)
      // Reset navigation flag after a short delay
      setTimeout(() => {
        isNavigatingRef.current = false
      }, 500)
    }

    return () => {
      setShowEditModalQuill(false)
    }
  }, [showEditModalQuill, card, setShowEditModalQuill])

  const closeModal = (modalId: string) => {
    setModalStates((prev) => ({...prev, [modalId]: false}))
    // Only clear history and reset if we're not navigating to another card/page
    if (!isNavigatingRef.current) {
      setCurrentCard(null)
      clearHistory()
      setLocalCanGoBack(false)
    }
  }

  const handleNavigateBack = (modalId: string) => {
    const previousCard = goBackInHistory()
    if (previousCard) {
      // Close current modal
      setModalStates((prev) => ({...prev, [modalId]: false}))
      // Open previous card's modal
      setCurrentCard(previousCard)
      setCard(previousCard)
      setModalStates((prev) => ({...prev, [previousCard.id]: true}))
      // Update local canGoBack immediately (cardHistory.length - 1 because we just popped)
      setLocalCanGoBack(cardHistory.length > 1)
    } else {
      // No history, just close and clear
      setModalStates((prev) => ({...prev, [modalId]: false}))
      setCurrentCard(null)
      clearHistory()
      setLocalCanGoBack(false)
    }
  }

  return (
    <>
      {Object.keys(modalStates).map(
        (modalId) =>
          modalStates[modalId] && currentCard && currentCard.id === modalId && (
            currentCard.title ?
            <EditPageModal
            key={modalId}
            // boardName={boardName}
            // sendTocHeading={sendTocHeading} setSendTocHeading={setSendTocHeading}
            pages={pages}
            page={currentCard} theme={theme} pageModalShow={modalStates[modalId]} setPageModalShow={() => closeModal(modalId)} canGoBack={localCanGoBack} onNavigateBack={() => handleNavigateBack(modalId)} />
            :
            <EditNewCard
              key={modalId}
              cardTitle='Edit Card'
              isBoard={false}
              cardDetails={currentCard}
              cardModalShow={modalStates[modalId]}
              setCardModalShow={() => closeModal(modalId)}
              canGoBack={localCanGoBack}
              onNavigateBack={() => handleNavigateBack(modalId)}
            />
          )
      )}
    </>
  )
}

export default LinkCardUpdate
